import { Card, CardBody, Col, Input, Label } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { SwitchSizings } from "../../../../Constant";
import { SWITCH_SIZING, SWITCH_SIZING_LIST } from "../../../../Data/FormWidgets";

const SwitchSizing = () => {
  return (
    <Col md="12">
      <Card>
        <CommonCardHeader title={SwitchSizings} span={SWITCH_SIZING} />
        <CardBody className="common-flex switch-wrapper">
          {SWITCH_SIZING_LIST.map(({ label, flexClass, defaultChecked, disabled }, index) => (
            <div className="d-flex" key={index}>
              <Label className="col-form-label m-r-10" check>
                {label}
              </Label>
              <div className={`flex-grow-1 text-end ${flexClass}`}>
                <Label className="switch">
                  <Input type="checkbox" defaultChecked={defaultChecked} disabled={disabled} />
                  <span className="switch-state"></span>
                </Label>
              </div>
            </div>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default SwitchSizing;
